import {h, Fragment} from "preact"
import { defaultConfig } from "../config"

export function SkeletonProduct() {
    return (
        <div class="nosto-skeleton-card">
            <div class="nosto-skeleton-card__image"></div>
            <div class="nosto-skeleton-card__text"></div>
            <div class="nosto-skeleton-card__text nosto-skeleton-card__text--short"></div>
        </div>
    )
}

export function SkeletonLoader() {

    return (
        <div class="collection__main">
            <product-list class="nosto-skeleton-grid">
                {Array.from({ length: defaultConfig.serpSize }, (_, i) => (
                    <SkeletonProduct key={i} />
                ))}
            </product-list>
        </div>
    )
}

export function SkeletonSidebar() {
    return <div class="ns-skeleton-sidebar ns-skeleton-fill" />
}